interface Props {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const sizes = { sm: 'w-4 h-4', md: 'w-8 h-8', lg: 'w-12 h-12' };

export function Spinner({ size = 'md', label = 'Loading…' }: Props) {
  return (
    <div
      className={`${sizes[size]} animate-spin rounded-full border-2 border-gray-300 dark:border-gray-600 border-t-brand-600 dark:border-t-brand-400`}
      role="status"
    >
      <span className="sr-only">{label}</span>
    </div>
  );
}
